export const gravatarQueryKeys = {
  url: ['url'] as const,
};
